import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser, faPen } from '@fortawesome/free-solid-svg-icons';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState('');
  const [isSending, setIsSending] = useState(false); // Pour l'animation

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus('Envoi en cours...');

    emailjs
      .send(
        'service_rwtwala',
        'template_1u4remq',
        {
          ...formData,
          time: new Date().toLocaleString(),
        },
        'oE86vhREUuB0nfQMM'
      )
      .then(() => {
        setStatus('Message envoyé avec succès !');
        setFormData({ name: '', subject: '', email: '', message: '' });
        setIsSending(false);
      })
      .catch((error) => {
        console.error(error);
        setStatus("Erreur lors de l'envoi. Veuillez réessayer plus tard.");
        setIsSending(false);
      });
  };

  return (
    <div className="bg-slate-50 dark:bg-slate-950 py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <img
          src="images/contact.png"
          alt="Illustration de contact"
          className="w-40 h-40 mx-auto mb-6"
        />
        <h1 className="text-4xl font-bold text-blue-600 mb-4">Contactez-nous</h1>
        <p className="text-gray-600 dark:text-gray-400">
          Nous serions ravis d’échanger avec vous. Envoyez-nous un message et nous vous répondrons rapidement.
        </p>

        {/* Adresse email visible */}
        <div className="mt-4 flex justify-center items-center gap-2 text-blue-600 text-lg font-medium">
          <FontAwesomeIcon icon={faEnvelope} className="text-blue-600" />
          <a href="mailto:lizaytechnology@gmail.com" className="hover:underline">
            lizaytechnology@gmail.com
          </a>
        </div>

        {/* Formulaire de contact */}
        <form
          onSubmit={handleSubmit}
          className="bg-white dark:bg-gray-900 mt-10 p-8 rounded-2xl shadow-xl space-y-6"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative">
              <label className="block mb-1 text-sm font-medium">Nom</label>
              <input
                type="text"
                name="name"
                placeholder="Votre nom"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <FontAwesomeIcon icon={faUser} className="absolute right-4 top-10 text-blue-500" />
            </div>

            <div className="relative">
              <label className="block mb-1 text-sm font-medium">Sujet</label>
              <input
                type="text"
                name="subject"
                placeholder="Sujet"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <FontAwesomeIcon icon={faPen} className="absolute right-4 top-10 text-blue-500" />
            </div>
          </div>

          <div className="relative">
            <label className="block mb-1 text-sm font-medium">Adresse email</label>
            <input
              type="email"
              name="email"
              placeholder="Votre adresse email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <FontAwesomeIcon icon={faEnvelope} className="absolute right-4 top-10 text-blue-500" />
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium">Message</label>
            <textarea
              name="message"
              placeholder="Votre message"
              rows={5}
              value={formData.message}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex justify-center items-center gap-4">
            <button
              type="submit"
              disabled={isSending}
              className={`flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition duration-300 ${
                isSending ? 'opacity-70 cursor-not-allowed' : ''
              }`}
            >
              {isSending ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                  </svg>
                  Envoi en cours...
                </>
              ) : (
                'Envoyer le message'
              )}
            </button>

            <p
              className={`text-sm mt-2 ${
                status.includes('succès') ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {status}
            </p>
          </div>
        </form>   
      </div>

      <div className="p-4 w-full">
          <iframe
            width="100%"
            height="400"
            className="rounded-lg"
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.339057049421!2d-69.78140522503836!3d18.468294982615213!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eaf87955792e979%3A0x98a7736f3c465bc0!2sPlaza%20Comercial%20Terrazul!5e0!3m2!1sen!2sdo!4v1724453944953!5m2!1sen!2sdo"
            style={{ filter: 'grayscale(0) contrast(1.5) opacity(0.9)' }}
          ></iframe>
        </div>
    </div>
  );
}

export default Contact;
